<template>
    <div class="text-field-with-symbol">
        <label ref="label-id" :for="name" v-bind:style="{fontWeight: fontWeight }">{{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">{{ symbol }}</span>
            </div>
            <input ref="text-field-input" type="text" v-model="displayValue" v-on:blur="focusOut" v-on:focus="saveCurrentValue" v-on:change="validateValue" :readonly="disabled" v-bind:class="{'disabled-field': disabled, 'text-danger': isErrorText, 'not-entered-input': purchasePriceNotEntered}" class="form-control text-field-input" :id="name" :placeholder="placeholder" :aria-label="placeholder" aria-describedby="basic-addon1">
        </div>
    </div>
</template>

<script>
    import CashflowCalculations from '../store/CashflowCalculations';

    export default {
        name: "text-field-with-symbol",
        data () {
            return {
                activeTooltip: false,
                currentValue: '',
                activeInput: false
            }
        },
        props: {
            name: String,
            value: Number,
            placeholder: String,
            label: String,
            symbol: String,
            isBoldFont: Boolean,
            hasTooltip: Boolean,
            disabled: {
                type: Boolean,
                default: false
            },
            isErrorText: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            labelPartOne: function () {
                var labelArray = this.label.split(" ");

                if (labelArray.length >= 3 && labelArray[labelArray.length - 1].length <= 3) {
                    labelArray.pop();
                    labelArray.pop();
                    return labelArray.join(" ");
                }

                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                var labelArray = this.label.split(" ");

                if (labelArray.length >= 3 && labelArray[labelArray.length - 1].length <= 3) {
                    var lastWord = labelArray.pop();
                    return labelArray.pop() + " " + lastWord;
                }

                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            fontWeight: function () {
                return this.isBoldFont ? 'bold' : 'normal';
            },
            displayValue: {
                get: function () {
                    if (this.activeInput) {
                        return this.value;
                    } else {
                        var currencyValue = this.value.toLocaleString('en-US',{useGrouping:true});
                        return currencyValue;
                    }
                },
                set: function (newValue) {
                    this.value = newValue.replace(",", "");
                }
            },
            tooltipText: function () {
                var helpText = "";

                switch (this.name) {
                    case 'Purchase-Price':
                        helpText = "The price of the property as reflected on the contract of " +
                            "sale or its most recent valuation";
                        break;
                    case 'Stamp-Duty':
                        helpText = "Stamp duty is a government fee based on the purchase price and State. " +
                            "This automated result is applicable for Australian citizens only";
                        break;
                    case 'Pre-purchase-Costs':
                        helpText = "Due diligence costs such as building and pest inspections, " +
                            "soil test, surveys, strata searches etc";
                        break;
                    case 'Other-Fees-And-Costs':
                        helpText = "Other costs associated with the purchase such as a Buyer's Agency fee " +
                            "or any other lending setup charges can be totalled here";
                        break;
                    case 'Legal-Fees':
                        helpText = "Solicitor or conveyancer fees for legal advice on the contract and settlement";
                        break;
                    case 'Council-Rates':
                        helpText = "Based on location, lot size etc. Please contact the local council or " +
                            "a rates notice for a guide to this amount. An average amount of $2,400 has been " +
                            "adopted as a default value";
                        break;
                    case 'Insurance-or-Strata-Fees':
                        helpText = "This is the annual strata/body corporate fee for a unit/townhouse or " +
                            "building insurance if the property is a detached house. An average amount of " +
                            "$2,000 has been adopted as a default value";
                        break;
                    case 'Other-Expenses':
                        helpText = "Other tax-deductible yearly costs incurred in running the property such as " +
                            "water rates, maintenance, cleaning etc";
                        break;
                    case 'Loan-Amount':
                        helpText = "The loan amount is the money being borrowed for the property purchase. " +
                            "It will be automatically calculated based on the purchase price and deposit entered, " +
                            "or may be manually adjusted";
                        break;
                    case 'Lenders-Mortgage-Insurance':
                        helpText = "LMI is an initial fee charged by the bank if the loan amount is over 80% of " +
                            "the value of the property (i.e. LVR >80%). It is an automatically calculated estimate " +
                            "in this calculator. Please enquire with your lender for the exact amount payable";
                        break;
                    case 'Individual-Gross-Income':
                        helpText = "Purchaser's gross income or salary. This does not take any other factors " +
                            "which can influence the amount of tax paid, such as the Medicare Levy, " +
                            "HECS contributions, any rebates, deductions or other levies into account. " +
                            "Please consult your tax specialist for further information";
                        break;
                }

                return helpText;
            },
            purchasePriceNotEntered: function () {
                if (this.label === 'Purchase Price') {
                    return !this.$store.state.purchasePriceEntered;
                }

                return false;
            }
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            },
            saveCurrentValue: function () {
                if (this.label === 'Purchase Price') {
                    this.$store.commit('purchasePriceEntered', true);
                }

                this.$nextTick(() => {
                    this.currentValue = this.value;
                    if (this.value === 0) {
                        this.value = '';
                    }
                });

                var valueLength = this.value.toString().length;
                var textFieldInput = this.$refs['text-field-input'];
                setTimeout(function() {
                    textFieldInput.setSelectionRange(valueLength, valueLength);
                }, 0);

                this.activeInput = true;
            },
            focusOut: function () {

                if (this.value === '') {
                    this.value = 0;
                }

                this.activeInput = false;
            },
            validateValue: function () {

                if (this.label === 'Purchase Price' && this.value == 0) {
                    this.value = this.currentValue;
                } else if (this.value >= 0 && !isNaN(this.value)) {
                    if (this.symbol !== '%') {
                        this.value = Math.round(this.value);
                    } else if (this.symbol === '%') {
                        if (Math.floor(this.value) !== Number(this.value)) {
                            if (this.value.toString().split(".")[1].length > 2) {
                                this.value = Number(Math.round(Number(this.value+'e'+2))+'e-'+2);
                            }
                        }
                    }
                    this.currentValue = this.value;
                    this.$emit('calc', this.value);
                } else {
                    this.value = this.currentValue;
                }
            }
        },
        mounted() {

            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                    $vm.activeTooltip = !$vm.activeTooltip;
                });
        }
    }
</script>

<style scoped>

    label {
        float: left;
        width: 48% !important;
        font-size: 20px;
        color: #465978;
        margin-top: -7px;
        margin-bottom: 15px;
    }

    .input-group {
        width: 50%;
        margin-left: auto;
        font-size: 20px;
        margin-top: 0;
        align-self: start
    }

    .input-group-text {
        font-weight: bold;
        background-color: #fff;
        color: #465978;
        font-size: 18px;
        height: 38px;
    }

    .text-field-with-symbol {
        width: 85%;
        margin: 0 auto;
        font-size: 20px;
        display: flex;
    }

    .text-field-input {
        background-color: #fff;
        text-align: right;
        font-size: 20px;
    }

    .lenders-mortgage-insurance .input-group {
        float: right;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .not-entered-input {
        background-color: #ffcccc;
        border-width: 2px;
        border-color: #d9534f;
    }

    .purchase-price .calc-tooltip {
        width: 260px;
        height: 74px;
        top: -75px;
        margin-left: -475%;
    }

    .purchase-price .arrow-down {
        margin-left: 88px;
    }

    .stamp-duty .calc-tooltip {
        width: 260px;
        height: 106px;
        top: -107px;
        margin-left: -475%;
    }

    .stamp-duty .arrow-down {
        margin-left: 88px;
    }

    .legal-fees .calc-tooltip {
        width: 260px;
        height: 74px;
        top: -75px;
        margin-left: -475%;
    }

    .legal-fees .arrow-down {
        margin-left: 88px;
    }

    .pre-purchase-costs .calc-tooltip {
        width: 260px;
        height: 89px;
        top: -90px;
        margin-left: -475%;
    }

    .pre-purchase-costs .arrow-down {
        margin-left: 88px;
    }

    .other-costs .calc-tooltip {
        width: 260px;
        height: 105px;
        top: -106px;
        margin-left: -475%;
    }

    .other-costs .arrow-down {
        margin-left: 88px;
    }

    .council-rates .calc-tooltip {
        width: 260px;
        height: 124px;
        top: -125px;
        margin-left: -475%;
    }

    .council-rates .arrow-down {
        margin-left: 88px;
    }

    .insurance .calc-tooltip {
        width: 260px;
        height: 138px;
        top: -139px;
        margin-left: -475%;
    }

    .insurance .arrow-down {
        margin-left: 88px;
    }

    .other-expenses .calc-tooltip {
        height: 90px;
        top: -91px;
        margin-left: -475%;
    }

    .other-expenses .arrow-down {
        margin-left: 88px;
    }

    .loan-amount .calc-tooltip {
        width: 260px;
        height: 138px;
        top: -139px;
        margin-left: -475%;
    }

    .loan-amount .arrow-down {
        margin-left: 88px;
    }

    .lenders-mortgage-insurance .calc-tooltip {
        width: 260px;
        height: 154px;
        top: -155px;
        margin-left: -475%;
    }

    .lenders-mortgage-insurance .arrow-down {
        margin-left: 88px;
    }

    .individual-income .calc-tooltip {
        width: 400px;
        height: 120px;
        top: -121px;
        margin-left: -475%;
    }

    .individual-income .arrow-down {
        margin-left: 88px;
    }

    .disabled-field {
        cursor: pointer;
        background-color: #e9ecef;
    }

    .individual-income label {
        margin-bottom: -30px;
    }

    @media (min-width: 1524px) {
        .individual-income .calc-tooltip {
            width: 570px;
            height: 90px;
            top: -91px;
        }
    }

    @media (min-width: 1287px) {
        .insurance .calc-tooltip {
            margin-left: -115%;
        }

        .insurance .arrow-down {
            margin-left: 15px;
        }
    }

    @media (min-width: 1063px) and (max-width: 1262px) {
        .other-expenses .calc-tooltip {
            margin-left: -115%;
        }

        .other-expenses .arrow-down {
            margin-left: 15px;
        }
    }

    @media (min-width: 768px) and (max-width: 1140px) {
        .purchase-price .calc-tooltip {
            margin-left: -145%;
        }

        .purchase-price .arrow-down {
            margin-left: 21px;
        }
    }

    @media (min-width: 768px) {
        .property-management-textfield .calc-tooltip {
            margin-left: -175%;
        }

        .property-management-textfield .arrow-down {
            margin-left: 27px;
        }
    }

    @media (min-width: 768px) and (max-width: 1046px) {
        .council-rates .calc-tooltip {
            margin-left: -145%;
        }

        .council-rates .arrow-down {
            margin-left: 21px;
        }
    }

    @media (min-width: 768px) and (max-width: 1030px) {
        .calc-tooltip {
            margin-left: -145%;
        }

        .arrow-down {
            margin-left: 21px;
        }

        .stamp-duty .calc-tooltip {
            margin-left: -75%;
        }

        .stamp-duty .arrow-down {
            margin-left: 7px;
        }

        .pre-purchase-costs .calc-tooltip {
            margin-left: -280%;
        }

        .pre-purchase-costs .arrow-down {
            margin-left: 49px;
        }

        .other-costs .calc-tooltip {
            margin-left: -330%;
        }

        .other-costs .arrow-down {
            margin-left: 58px;
        }
    }

    @media (min-width: 768px) and (max-width: 960px) {
        .insurance .calc-tooltip {
            margin-left: -75%;
        }

        .insurance .arrow-down {
            margin-left: 7px;
        }

        .property-management-textfield .calc-tooltip {
            margin-left: -175%;
        }

        .property-management-textfield .arrow-down {
            margin-left: 27px;
        }
    }

    @media (min-width: 768px) and (max-width: 947px) {

        .loan-amount .calc-tooltip {
            margin-left: -375%;
        }

        .loan-amount .arrow-down {
            margin-left: 67px;
        }

    }

    @media (min-width: 768px) and (max-width: 845px) {
        .property-management-textfield label {
            font-size: 19px;
        }

        .other-expenses .calc-tooltip {
            margin-left: -75%;
        }

        .other-expenses .arrow-down {
            margin-left: 7px;
        }
    }

    @media (min-width: 768px) and (max-width: 811px) {
        .capital-growth .calc-tooltip{
            margin-left: -75%;
        }

        .capital-growth .arrow-down{
            margin-left: 7px;
        }
    }

    @media (max-width: 780px) {

        .calc-tooltip {
            margin-left: -145%;
        }

        .arrow-down {
            margin-left: 21px;
        }
    }

    @media (min-width: 1024px) {
        .text-field-with-symbol {
            margin-bottom: 12px;
        }

        label {
            margin-bottom: 0;
        }

        .loan-amount, .individual-income {
            margin-bottom: 0 !important;
        }
    }

    @media (max-width: 1024px) {
        .individual-income .calc-tooltip {
            width: 570px;
            height: 88px;
            top: -89px;
            margin-left: -765%;
        }

        .individual-income .arrow-down {
            margin-left: 145px;
        }
    }

    @media (max-width: 734px) {
        .individual-income .calc-tooltip {
            margin-left: -1245%;
        }

        .individual-income .arrow-down {
            margin-left: 241px;
        }
    }

    @media (max-width: 664px) {
        .individual-income .calc-tooltip {
            width: 400px;
            height: 120px;
            top: -121px;
            margin-left: -145%;
        }

        .individual-income .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 590px) {
        .pre-purchase-costs .calc-tooltip, .other-costs .calc-tooltip {
            margin-left: -145%;
        }

        .pre-purchase-costs .arrow-down, .other-costs .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 530px) {
        .individual-income .calc-tooltip {
            width: 380px;
            height: 120px;
            top: -121px;
            margin-left: -650%;
            padding-left: 1px;
            padding-right: 1px;
        }

        .individual-income .arrow-down {
            margin-left: 129px;
        }
    }

    @media (max-width: 396px) {
        .lenders-mortgage-insurance .calc-tooltip {
            margin-left: -145%;
        }

        .lenders-mortgage-insurance .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 435px) {

        .input-group {
            width: 50%;
        }

        .purchase-price .calc-tooltip {
            margin-left: -145%;
        }

        .purchase-price .arrow-down {
            margin-left: 21px;
        }

    }

    @media (max-width: 399px) {
        .other-expenses .calc-tooltip, .property-management-textfield .calc-tooltip, .loan-amount .calc-tooltip {
            margin-left: -75%;
        }

        .other-expenses .arrow-down, .property-management-textfield .arrow-down, .loan-amount .arrow-down {
            margin-left: 7px;
        }
    }

    @media (min-width: 404px) and (max-width: 416px) {
        .loan-amount .calc-tooltip {
            margin-left: -145%;
        }

        .loan-amount .arrow-down {
            margin-left: 21px;
        }
    }

    @media (min-width: 295px) and (max-width: 412px) {
        .capital-growth .calc-tooltip {
            margin-left: -105%;
        }

        .capital-growth .arrow-down {
            margin-left: 13px;
        }
    }

    @media (max-width: 357px) {
        .council-rates .calc-tooltip {
            margin-left: -145%;
        }

        .council-rates .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 400px) {
        .individual-income .calc-tooltip {
            width: 340px;
            height: 120px;
            top: -121px;
            margin-left: -625%;
            padding-left: 5px;
            padding-right: 5px;
            font-size: 14px;
        }

        .individual-income .arrow-down {
            margin-left: 120px;
        }
    }

    @media (max-width: 365px) {
        .other-expenses .calc-tooltip, .insurance .calc-tooltip{
            margin-left: -275%;
        }

        .other-expenses .arrow-down, .insurance .arrow-down {
            margin-left: 47px;
        }
    }

    @media (min-width: 361px) and (max-width: 373px) {
        .stamp-duty .calc-tooltip {
            margin-left: -330%;
        }

        .stamp-duty .arrow-down {
            margin-left: 58px;
        }
    }

    @media (max-width: 361px) {
        .stamp-duty .calc-tooltip {
            margin-left: -75%;
        }

        .stamp-duty .arrow-down {
            margin-left: 7px;
        }
    }

    @media (max-width: 361px) {
        .individual-income .calc-tooltip {
            width: 280px;
            height: 137px;
            top: -138px;
            margin-left: -525%;
            padding-left: 1px;
            padding-right: 1px;
        }

        .individual-income .arrow-down {
            margin-left: 104px;
        }
    }

    @media (max-width: 341px) {
        .insurance .calc-tooltip {
            margin-left: -75%;
        }

        .insurance .arrow-down {
            margin-left: 7px;
        }

        .capital-growth .calc-tooltip {
            margin-left: -255%;
        }

        .capital-growth .arrow-down {
            margin-left: 43px;
        }
    }

    @media (max-width: 336px) {
        .loan-amount .calc-tooltip {
            margin-left: -255%;
        }

        .loan-amount .arrow-down {
            margin-left: 43px;
        }
    }

    @media (max-width: 329px) {

        .pre-purchase-costs .calc-tooltip {
            margin-left: -280%;
        }

        .pre-purchase-costs .arrow-down {
            margin-left: 49px;
        }

        .other-costs .calc-tooltip {
            margin-left: -330%;
        }

        .other-costs .arrow-down {
            margin-left: 57px;
        }
    }

    @media (max-width: 404px) {
        .loan-amount .calc-tooltip {
            margin-left: -285%;
        }

        .loan-amount .arrow-down {
            margin-left: 49px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/TextFieldWithSymbol.vue